package com.fireavert.tenants.data_models

enum class TenantStatus {
    Current, Active, Former, Future, Applicant, Evicted, Deceased, Archived, Unknown;

    companion object {
        fun findByText(text: String?): TenantStatus? {
            if (text == null) return null
            return values().find { it.name.equals(text, ignoreCase = true) }
        }

        fun fromText(text: String?): TenantStatus {
            return findByText(text) ?: Active // Default to Active if not found
        }

        fun fromTextOrNull(text: String?): TenantStatus? {
            return findByText(text)
        }
    }
}

